import type { UploadSlot } from '../api/docai'

// Mirrors apps/api/internal/db/migrations/00004_documents_processing.sql's
// documents_slot_check — every slot a document can be persisted under.
export const DOCUMENT_SLOT_LABELS: Record<UploadSlot, string> = {
  certificate_of_incorporation: 'Certificate of Incorporation',
  license: 'Company Licence',
  incumbency: 'Certificate of Incumbency',
  shareholders_certificate: 'Certificate of Shareholders',
  directors_certificate: 'Certificate of Directors',
  shareholder_passport: 'Shareholder Passport',
  shareholder_proof_of_address: 'Shareholder Proof of Address',
  director_passport: 'Director Passport',
}
